<template>
    <div class="container" oncontextmenu="return false" ondragstart="return false">
        <div class="snapshot-area disabled" ref="snapshotArea">
            <img id="snapshot_image" class="snapshot-image" src="" ref="snapshotImage">
        </div>
        <div class="kollus-player-area">
            <iframe id="kollus_player" class="iframe" src="" ref="kollusPlayer" allow="encrypted-media *; autoplay; fullscreen;" frameborder="0" allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>
        </div>
        <div v-show="livePlayerStatus" class="live_player_status text-primary">
            <i class="icon icon-info-circle-line"></i><span> {{ livePlayerStatus }}</span>
        </div>
    </div>
</template>

<script>
import './VideoPlayer.scss';
import ControllerEvent from './const/ControllerEvent';
import BroadcastStatus from './const/BroadcastStatus';

const PLAYER_TYPE = {
    LIVE: 'live',
    VOD: 'vod',
};

export default {
    name: 'VideoPlayer',
    props: {
        playerId: null,
        mediainfo: null,
        broadcastStatus: null,
        isShowSnapshotImage: false,
    },
    data() {
        return {
            livePlayerStatus: '',
            pickedMediaInfo: null,
            playWaitingMediaInfo: null,
        };
    },
    mounted() {
        if (this.playerType === PLAYER_TYPE.LIVE) {
            this.setLivePlayer();
        } else {
            this.initVodPlayer();
        }
    },
    beforeDestroy() {
        if (this.controller) {
            this.controller.dispose();
        }
    },
    computed: {
        playerType() {
            return 'latest_live_media_broadcast' in this.mediainfo ? PLAYER_TYPE.LIVE : PLAYER_TYPE.VOD;
        },
        isOnAir() {
            return this.playerType === PLAYER_TYPE.LIVE
                && 'is_onair' in this.mediainfo.latest_live_media_broadcast
                && this.mediainfo.latest_live_media_broadcast.is_onair;
        },
        kollusPlayer() {
            return this.$refs.kollusPlayer;
        },
        snapshotArea() {
            return this.$refs.snapshotArea;
        },
        snapshotImage() {
            return this.$refs.snapshotImage;
        },
        controller() {
            return new VgControllerClient({
                target_window: this.$refs.kollusPlayer.contentWindow
            });
        }
    },
    methods: {
        setLivePlayer() {
            this.livePlayerStatus = '';
            // https://catenoid.atlassian.net/browse/KLC-18 패치 해제
            if (this.isOnAir) {
                this.kollusPlayer.setAttribute('src', this.mediainfo.preview_url);
                this.controller.on(ControllerEvent.READY, () => {
                    this.controller.play();
                });
                this.kollusPlayer.classList.remove('off-air');
            } else {
                this.isShowSnapshotImage = false;
                this.kollusPlayer.setAttribute('src', '');
                this.kollusPlayer.classList.add('off-air');
            }
        },
        setVodPlayer() {
            if ('preview_media_url' in this.pickedMediaInfo && this.pickedMediaInfo.preview_media_url.length > 0) {
                this.$emit('update:playingFile', this.pickedMediaInfo);

                this.kollusPlayer.setAttribute('src', this.pickedMediaInfo.preview_media_url);
                //TODO: 녹화 VOD Play/Shift 위해서는 Multiple Iframe Issue (https://trello.com/c/7Uzrq9Xt) 해결 필요 (현재 미동작)
                this.controller
                    .on(ControllerEvent.READY, () => {
                        this.controller.play();
                    })
                    .on(ControllerEvent.DONE, () => {
                        if (_.isArray(this.mediainfo) && this.mediainfo.length > 0) {
                            this.pickedMediaInfo = this.playWaitingMediaInfo.shift();
                            this.setVodPlayer();
                        }
                    });
            }
        },
        checkMediaUrlValidate() {//TODO: WebRTC 포함하기 위해 사용 보류
            // console.log('checkMediaUrlValidate');
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.onreadystatechange = () => {
                    // console.log(xhr);
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            // console.log('mediaUrl is validated!');
                            resolve(xhr.responseText);
                        } else {
                            reject();
                        }
                    }
                };
                xhr.open('GET', this.mediainfo.latest_live_media_broadcast.monitor_media_url, true);
                xhr.send(null);
            });
        },
        getCacheBustedUrl(url) {
            return `${url}${url.indexOf('?') > -1 ? '&' : '?'}_bust=${this.$moment.valueOf()}`;
        },
        initVodPlayer() {
            if (_.isArray(this.mediainfo) && this.mediainfo.length > 0) {
                this.playWaitingMediaInfo = this.mediainfo.slice(0);
                this.pickedMediaInfo = this.playWaitingMediaInfo.shift();
            } else {
                this.pickedMediaInfo = this.mediainfo;
            }

            this.setVodPlayer();
        },
    },
    watch: {
        isShowSnapshotImage(value) {
            if (value) {
                //this.$store.dispatch('setPlayerSnapshot', { muted: this.player.muted() });
                this.snapshotImage.setAttribute('src', this.getCacheBustedUrl(this.mediainfo.snapshot_url));
                this.snapshotArea.classList.remove('disabled');
            } else {
                //this.setLivePlayer();
                this.snapshotImage.setAttribute('src', '');
                this.snapshotArea.classList.add('disabled');
            }
        },
        broadcastStatus(value) {
            // console.log('broadcastStatus : ' + value);
            switch (value) {
            case BroadcastStatus.STARTED:
                this.livePlayerStatus = this.$t('paragraphs.channel.mornitorring_message.broadcast_start');
                break;
            case BroadcastStatus.PAUSED:
                this.livePlayerStatus = this.$t('paragraphs.channel.mornitorring_message.broadcast_stop');
                break;
            case BroadcastStatus.STOPPED:
                this.livePlayerStatus = '';
                break;
            default:
                this.livePlayerStatus = '';
                break;
            }

            let tm = setInterval(() => {
                clearInterval(tm);
                this.setLivePlayer();
            }, 5000);
        },
        mediainfo(newValue) {
            if (this.playerType === PLAYER_TYPE.VOD) {
                this.initVodPlayer();
            }
        },
    },
};
</script>

<style scoped>
    .live_player_status {
        margin-top: 10px;
    }
</style>
